import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PdfTab from './PdfTab';
import SpreadsheetTab from './SpreadsheetTab';

export default function MainUploadPage() {
    const navigate = useNavigate()
    /* Will have 2 tabs for Total and Location based analytics */
    const [value, setValue] = useState(0);
    const [searchParams, setSearchParams] = useSearchParams()

    const handleChange = (event, newValue) => {
        // setSearchParams({ page: newValue })
        setSearchParams(prev => {
            const newParams = new URLSearchParams(prev);
            newParams.set('page', newValue + 1)
            return newParams;
        })
        setValue(newValue);
    };

    useEffect(() => {
        const pageIndex = searchParams.get("page")
        if (pageIndex !== null) {
            setValue(Number(pageIndex) - 1)
        }
    }, [searchParams])

    const tabPage = (index) => {
        switch (index) {
            case 0:
                return <PdfTab />
            case 1:
                return <SpreadsheetTab />
            default:
                return <PdfTab />;
        }
    }
    return (
        <>
            <div className="card border-0"
                style={{
                    height: "calc(100vh - 56px)",
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                <div className="card-header bg-white"
                    style={{
                        padding: '0 20px 5px 20px',
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                        borderBottom: '1px solid #eee'
                    }}
                >
                    <h2 style={{ margin: 0, paddingTop: '10px' }}>File Upload</h2>
                </div>
                <div className="card-body tab-head">
                    <Tabs value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example">
                        <Tab label="PDF Upload" sx={{ textTransform: 'none' }} />
                        <Tab label="CSV Upload" sx={{ textTransform: 'none' }} />
                    </Tabs>
                    {tabPage(value)}
                </div>
            </div >
        </>
    )
};